import _extends from "@swc/helpers/src/_extends.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import React, { useMemo, useState } from 'react';
import DropdownStateManager from '../DropdownStateManager';
import { PopupContext } from '@wix/da-ds/pkg/popups/PopupContext';
import noop from '../../utils/noop';
import { PopperDropdownContext } from './PopperDropdownContext';
const PopperDropdownManager = (_param)=>{
    var { children , isInPopup  } = _param, dropdownProps = _object_without_properties(_param, [
        "children",
        "isInPopup"
    ]);
    const [referenceElement, setReferenceElement] = useState(null);
    const contextData = useMemo(()=>({
            setToggleRef: setReferenceElement,
            toggleElement: referenceElement
        }), [
        referenceElement
    ]);
    return /*#__PURE__*/ React.createElement(DropdownStateManager, _extends({}, dropdownProps), /*#__PURE__*/ React.createElement(PopperDropdownContext.Provider, {
        value: contextData
    }, isInPopup ? /*#__PURE__*/ React.createElement(PopupContext.Provider, {
        value: {
            isInPopup: true,
            setScrollableContentRef: noop
        }
    }, children) : children));
};
PopperDropdownManager.displayName = 'PopperDropdownManager';
export default PopperDropdownManager;
